var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[_c('CockpitMatryoshkaInheritanceTree',{attrs:{"label-archive-id":_vm.labelArchiveId,"init-order-id":_vm.orderId},on:{"connections-updated":function($event){return _vm.$emit('connections-updated', $event)},"go-to-serial-number":function($event){return _vm.$emit('go-to-serial-number', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }